export default __webpack_public_path__ + "static/media/yourselfPhone.f15362e7.png";